import BaseComponent from "../../baseComponent.js";
import ColorUtil from "../../../core/utils/colorUtil.js";
import InternalEvent from "../../../core/constants/internalEvent";

class InputRow extends BaseComponent {
  componentDidMount() {
    let _this = this;
    let data = {
      dataset: this.props.datasetId
    };
    data[this.props.fieldId] = this.props.value;
    $(this.refs.value).attr("contenteditable", true)
      .on("keyup", function (e) {
        let lastChar = this.textContent.slice(-1);
        if (lastChar == "." || (this.textContent.indexOf(".") > -1 && lastChar == "0")) return;
        let value = parseFloat(this.textContent);
        if (!isNaN(value)) {
          data[_this.props.fieldId] = value;
          _this.props.onValueChange(data);
        }
      })
      .focusout(function () {
        // _this.props.onValueChange(data);
      });
  }

  handleDragStart(event) {
    event.dataTransfer.effectAllowed = "move";
    const data = {
      dataset: {
        name: this.props.datasetRefId,
        persistenceId: this.props.datasetId
      },
      field: {
        fieldId: this.props.fieldId,
        name: this.props.fieldId
      }
    };
    // event.dataTransfer.setData("datasetId", this.props.datasetId);
    // event.dataTransfer.setData("fieldId", this.props.fieldId);
    event.dataTransfer.setData("source", "input");
    // event.dataTransfer.setData('text', this.props.datasetRefId + "." + this.props.fieldId);
    event.dataTransfer.setData("data", JSON.stringify(data) );
    this.publish(InternalEvent.Dashboard.AddWidget.FIELD_DRAG_START);
  }

  handleDragEnd() {
    this.publish(InternalEvent.Dashboard.AddWidget.FIELD_DRAG_END);
  }

  handleMouseDown(e) {
    this.props.onCellClicked(this.props.datasetRefId, this.props.fieldId);
  }

  render() {
    let id = this.props.datasetRefId + "." + this.props.fieldId;
    let fieldIdCellStyle = {
      backgroundColor: this.props.color,
      borderColor: ColorUtil.shadeColor(this.props.color, -10)
    };
    return (
      <tr>
        <td className="studio-spreadsheet__field-id spreadsheet-selectable"
            style={fieldIdCellStyle}>
          <div draggable="true"
               onDragStart={this.handleDragStart}
               onDragEnd={this.handleDragEnd} style={{zIndex: 10}}>{this.props.fieldId}</div>
          <div data-ref={id} className="select-overlay"></div>
        </td>
        <td id={id} className="studio-spreadsheet__value spreadsheet-selectable"
            onMouseDown={this.handleMouseDown}>
          <div ref="value" style={{outline: "none", zIndex: 10}}>
            {this.props.value}
          </div>
          <div data-ref={id} className="select-overlay"></div>
        </td>
      </tr>
    );
  }
}


export default class Input extends BaseComponent {
  render() {
    let fieldIds = Object.keys(this.props.datasetInputModel.fields);
    let rows = [];

    for (let i = 0; i < this.props.numRows; i++) {
      let fieldId = fieldIds[i] || "";
      let value = fieldId != "" ? this.props.datasetInputModel.fields[fieldId].value : "";
      rows.push(<InputRow
        onCellClicked={this.props.onCellClicked}
        onValueChange={this.props.onValueChange}
        datasetId={this.props.datasetInputModel.datasetId}
        datasetRefId={this.props.datasetRef}
        fieldId={fieldId}
        color={this.props.datasetInputModel.color}
        value={value}
        key={i}
      />);
    }

    return (
      <div className="spreadsheet-input-dataset">
        <table ref="table">
          <tbody>
          {rows}
          </tbody>
        </table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/analytic-studio/spreadsheet/input.jsx